export default {
  storeInspectionList(state, inspections) {
    state.inspections = inspections;
  },
  storeInspection(state, inspection) {
    state.inspection = inspection;
  },
  storeUpdatedInspection(state, updatedInspection) {
    state.inspection = updatedInspection;
  },
  resetAllInspections(state) {
    state.inspections = []
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/inspections/mutations.js